<script setup lang="ts">
import type { Swiper } from 'swiper/types';
import type { ServicesRelaxCarouselSlide } from '.';

const services: ServicesRelaxCarouselSlide[] = [
  {
    title: 'Finská sauna (suché teplo)',
    description: `<p>Klasická finská sauna s teplotou 85–90 °C nabízí až 2 hodiny absolutního klidu a pohody. Délku prohřívání nechte čistě na svém pocitu, poté se zchlaďte ve sprše, vědru či kádi a odpočiňte si v relaxační zóně s příjemnou hudbou a drinkem. Pro dosažení maximálního regeneračního účinku doporučujeme tento proces alespoň třikrát zopakovat.</p>`,
    image: {
      url: '/images/sauna/finska.webp',
      alt: 'Interiér dřevěné finské sauny',
    },
  },
  {
    title: 'Bio sauna s párou a bylinkami',
    description: `<p>Tato jemnější varianta saunování s teplotou 70 °C vám poskytne celé 2 hodiny pro dokonalé uvolnění. Během relaxace budete dýchat příjemně vlhký vzduch, který je provoněný bylinkami přesně podle vašeho výběru, což přispívá k hluboké relaxaci těla i mysli.</p>`,
    image: {
      url: '/images/sauna/bio.webp',
      alt: 'Bio sauna s bylinkovou párou',
    },
  },
  {
    title: 'Infrasauna (hloubkové prohřátí)',
    description: `<p>Během maximálně 35 minut infrasauna prohřeje vaše svaly do hloubky, zrychlí metabolismus a podpoří hubnutí. Zároveň stimuluje tvorbu kolagenu a prokazatelně pomáhá zmírňovat akné, ekzémy i celulitidu. Pokud chcete zážitek umocnit, vyzkoušejte ihned po sauně masáž – díky prohřátým svalům bude její účinek mnohem intenzivnější a efektivnější. <br><br><em>Upozornění: Infrasauna není vhodná pro těhotné ženy a osoby s prsními implantáty, kovovými náhradami či kardiostimulátory.</em></p>`,
    image: {
      url: '/images/sauna/infra.webp',
      alt: 'Infrasauna pro hloubkové prohřátí',
    },
  },
];
const swiper = useTemplateRef('swiper_ref');
defineExpose({
  swiper: computed(() => swiper.value?.swiper as Swiper | undefined),
});
</script>

<template>
  <div class="h-min w-full xl:w-[58%]">
    <Swiper
      ref="swiper_ref"
      :opts="{
        slidesPerView: 1.149234694, // based on design
        spaceBetween: 16,
        centeredSlides: true,
        centeredSlidesBounds: true,
        grabCursor: true,
        keyboard: true,
      }"
      class="cursor-grab"
    >
      <ServicesRelaxSaunaCarouselSlide
        v-for="(service, i) in services"
        :key="i"
        :item="service"
      />
    </Swiper>
  </div>
</template>
